import { MessageBar, MessageBarType } from "@fluentui/react";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Text } from "sprint-common-web";

import { orderDashboardRoute } from "../../OrdersRoutes";
import { OrderDashboardContext } from "./provider/OrderDashboardContext";

export const OrderOverriddenInfo = (): JSX.Element | null => {
    const { orderDashboardItem } = useContext(OrderDashboardContext);
    const { push } = useHistory();

    if (!orderDashboardItem.overridenById) return null;

    const { overridenById } = orderDashboardItem;
    return (
        <div style={{ padding: "10px 0" }}>
            <MessageBar messageBarType={MessageBarType.warning} isMultiline={true}>
                <Text>
                    Record has been overriden by another{" "}
                    <span
                        onClick={() => push(orderDashboardRoute.path.replace(":orderId", overridenById))}
                        style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                        order
                    </span>
                </Text>
            </MessageBar>
        </div>
    );
};
